<template>
  <b-container>
    <b-alert class='mt-2' variant=warning :show=error>{{alert}}</b-alert>
    <b-row class="mb-2 mt-1">
      <b-col v-for="num,ix in nums" :key=ix>
        <b-card>
          <b-card-body>
            BOM/KIT {{ix+1}}
            <b-input v-model="nums[ix]" @keyup.enter="computeDiff" @input='getData(ix)' />
            <div v-if="items[ix].product_desc || items[ix].part_desc">
              <hr />
              <span>{{items[ix][items[ix].product_desc !== '' ? 'product_desc' : 'part_desc']}}</span>
            </div>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-btn block @click.prevent="computeDiff" class='mb-4'>
          Compare
        </b-btn>
      </b-col>
    </b-row>
    <b-row v-if='busy'>
      <b-col>
        <center>
          <fingerprint-spinner :animation-duration="1500" :size="300" color="#293a93" class="my-3" />
        </center>
      </b-col>
    </b-row>
    <b-row v-else>
      <b-col>
        <center>
          What do these colors mean?
          <b-button size="sm" variant="link" class="px-0" v-b-modal.modal>
            <i class="fas fa-question-circle"></i>
          </b-button>
        </center>
        <b-table :items=output :fields=columns>
          <template slot='num' slot-scope=row>
            <router-link
              :to="{ path: '/inventory/qty-calculations', query: { partNum: row.item.num }}"
              target="_blank"
            >{{ row.item.num }}</router-link>
          </template>
          <template slot='web_qty' slot-scope=row>
            <center>
              <span>{{row.item.web_qty}}</span>
            </center>
          </template>
          <template slot='leftQty' slot-scope=row>
            <center>
              <span>{{row.item.leftQty}}</span>
            </center>
          </template>
          <template slot='rightQty' slot-scope=row>
            <center>
              <span>{{row.item.rightQty}}</span>
            </center>
          </template>
          <template slot='delta' slot-scope=row>
            <center>
              <span v-if="row.item.delta > 0">{{row.item.delta}}</span>
              <span v-else> </span>
            </center>
          </template>
        </b-table>
      </b-col>
    </b-row>
    <b-modal id='modal' centered scrollable hide-footer size="lg" title="More Info">
      <strong>Red</strong> highlighted Part/Product nums are items that aren't updated to the web, and the customer probably won't be able to buy them <br/>
      <strong>Yellow</strong> highlighted Product nums are items that are updated to the web, but are currently out of stock
    </b-modal>
  </b-container>
</template>

<script>
import axios from 'axios'
import { FingerprintSpinner } from 'epic-spinners';
import utility from '../../helpers/utility'
const BASE_API = process.env.VUE_API_ROOT;

export default {
  components: {
    FingerprintSpinner
  },
  data() {
    return {
      nums: [ this.$route.query.num1, this.$route.query.num2 ],
      items: [ { }, { } ],
      alert: '',
      error: false,
      busy: false,
      columns: [
        { key: 'num' },
        { key: 'description' },
        { key: 'web_qty' },
        { key: 'leftQty' },
        { key: 'rightQty' },
        { key: 'delta', label: 'Δ' },
      ],
      output: [ ]
    };
  },
  mounted() {
    Promise.all([this.getData(0), this.getData(1)]).then(() => this.computeDiff())
  },
  methods: {
    async computeDiff() {
      if (!this.nums[0] || !this.nums[1]) return

      this.busy = true;
      try {
        this.error = false;
        this.output = [ ]

        const items = [ ]

        const left = (await this.getItems(this.items[0]));
        const right = (await this.getItems(this.items[1]));
        if (this.error) return;

        left.forEach(item => {
          let foundItem = items.find(x => x.num == item.num)
          if (typeof(foundItem) === 'undefined') {
            item.leftQty = Number(item.qty)
            items.push(item)
          }
          else {
            foundItem.leftQty += Number(item.qty)
          }
        })
        right.forEach(item => {
          let foundItem = items.find(x => x.num == item.num)
          if (typeof(foundItem) === 'undefined') {
            item.rightQty = Number(item.qty)
            items.push(item)
          } else {
            if (!foundItem.rightQty) {
              foundItem.rightQty = 0
            }
            foundItem.rightQty += Number(item.qty)
          }
        })

        items.forEach(item => {
          item._cellVariants = { }

          item.delta = (
            (!item.rightQty || Number(item.rightQty) === NaN) ? 0 : Number(item.rightQty)) -
            ((!item.leftQty || Number(item.leftQty) === NaN) ? 0 : Number(item.leftQty)
          )
          if (!!item.leftQty) item.leftQty = utility.betterRound(item.leftQty, 4)
          if (!!item.rightQty) item.rightQty = utility.betterRound(item.rightQty, 4)
          item.delta = utility.betterRound(item.delta, 4)

          if (!item.isProduct) {
            item._cellVariants['num'] = 'danger'
          } else if (item.web_qty <= 0) {
            item._cellVariants['num'] = 'warning'
          }

          // highlights the difference between left and right columns, I guess we don't have a use for this, but I'm sure we will in like a week
          // if (!!item.leftQty && !!item.rightQty && item.leftQty !== item.rightQty) {
          //   if (item.leftQty < item.rightQty) {
          //     item._cellVariants = { leftQty: 'danger', rightQty: 'success' }
          //   } else {
          //     item._cellVariants = { leftQty: 'success', rightQty: 'danger' }
          //   }
          // }
        })
        items.sort((a,b) => a.num.localeCompare(b.num))

        this.output = items
      }
      finally {
        this.busy = false
      }
    },
    async getData(id) {
      this.output = [ ]
      this.items[id] = { }
      if (!this.nums[id]) return

      axios({
        method: 'post',
        headers: { 'Content-Type': 'text/plain' },
        url: `${BASE_API}/ams3-fishioninfo/part-info/search`,
        data: { exactMatch: true, productNum: this.nums[id] },
      }).then(response => {
        console.log(response.data)
        if (response.data.length === 0) {
          this.alert = `Could not find ${this.nums[id]}, is it a BOM or a KIT?`
          this.error = true;
          return undefined
        }

        if (response.data[0].item_type !== 'Kit' && response.data[0].item_type !== 'Bom') {
          this.alert = `${response.data[0].item_type} part type is not supported`
          this.error = true;
          return undefined;
        }

        this.items[id] = response.data[0];
        this.error = false
        this.$forceUpdate()
      })
    },
    async getItems(data) {
      return await Promise.all(data.lowest_parts.split(';').map(async item => {
        let splits = item.split(',')
        let itemNum = splits[0].replace(/\*+$/, '')
          let data = (await axios({
            method: 'post',
            headers: { 'Content-Type': 'text/plain' },
            url: `${BASE_API}/ams3-fishioninfo/part-info/search`,
            data: { exactMatch: true, productNum: itemNum },
          })).data[0];

          let isProduct = data['product_num'] !== "0" && data['updated_to_web']
          let r = {
            num: isProduct ? data['product_num'] : data['part_num'],
            description: isProduct ? data['product_desc'] : data['part_desc'],
            isProduct,
            web_qty: data['web_qty'],
            qty: splits[2],
          }
          return r
      }))
    },
  },
}
</script>

<style scoped>
.table thead th {
  text-align: center !important;
}
</style>



// WEBPACK FOOTER //
// src/components/inventory/BomKitDiff.vue